// src/components/EducationLoan.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./EducationLoan.css";

import Services from "./ServicesPages/Services";
import TestimonialsSection from "../common/testimonials-section";

const EducationLoan = () => {
  const navigate = useNavigate();

  return (
    <div className="education-container">
      <section className="lap-hero">
        <div className="lap-container">
          {/* LEFT VIDEO */}
          <div className="lap-video">
            <img
              src="/images/e.png"
              alt="Loan Against Property"
              className="hero-video"
            />
          </div>
          {/* RIGHT CONTENT */}
          <div className="lap-content">
            <h1>
              Turn Your Study Dreams into Reality with an
              <span> Education Loan!</span>
            </h1>

            <ul className="lap-points">
              <li>✔ Support for Higher Education</li>
              <li>✔ Affordable Interest Rates</li>
              <li>✔ Flexible Repayment After Study</li>
            </ul>

            <p>
              Achieve your academic goals without financial stress with our
              Education Loan solutions. Whether you want to pursue higher
              education in India or abroad, we help cover expenses such as
              tuition fees, hostel charges, books, and other study-related
              costs. With easy eligibility, competitive interest rates, and
              flexible repayment options, you can focus on building your future
              while we support your educational journey.
            </p>
          </div>
        </div>
      </section>
      <section className="loan-usage-section">
        <div className="loan-container">
          <div className="loan-left">
            <h2>
              Achieve Your Dreams with an <span>Education Loan</span>
            </h2>

            <p>
              Education loans help students pursue higher studies without
              financial stress. Whether you plan to study in India or abroad, an
              education loan covers major academic expenses and supports your
              future goals.
            </p>

            <p>
              <strong>Krishana Finconcept Services</strong> provides quick and
              reliable education loan solutions with flexible repayment options,
              minimal documentation, and competitive interest rates.
            </p>
          </div>

          <div className="loan-right">
            <div className="loan-card">
              <h4>Tuition Fees</h4>
              <p>
                Cover college or university tuition fees easily with flexible
                financing options.
              </p>
            </div>

            <div className="loan-card">
              <h4>Accommodation Costs</h4>
              <p>
                Manage hostel, rent, and living expenses during your studies.
              </p>
            </div>

            <div className="loan-card">
              <h4>Books & Study Materials</h4>
              <p>
                Pay for textbooks, study materials, and essential academic
                tools.
              </p>
            </div>

            <div className="loan-card">
              <h4>Study Abroad Expenses</h4>
              <p>
                Finance travel, visa, and other expenses required for studying
                abroad.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="homeload-main-section homeloan-section modern-variant unique-hero-design full-width-layout">
        <div className="homeloan-hero-text animated-entrance">
          {/* 1. Badge */}
          <div className="badge-glow animated-item">Invest In Your Future</div>

          {/* 2. Main Title */}
          <h1 className="title animated-item">
            Empower Your Dreams With Our <span>Education Loans!</span>
          </h1>

          {/* 3. Features Pills */}
          <div className="features-flex animated-item">
            <div className="feat-pill">
              <span className="icon">✔</span> Domestic & Overseas Coverage
            </div>
            <div className="feat-pill">
              <span className="icon">✔</span> Moratorium Period Benefits
            </div>
            <div className="feat-pill">
              <span className="icon">✔</span> Tax Benefits Under Sec 80E
            </div>
          </div>

          {/* 4. Description Body */}
          <div className="content-body animated-item">
            <p className="subtitle">
              Secure the best education for yourself or your children without
              financial constraints. <strong>Krishana Finconcept</strong> offers
              comprehensive Education Loan solutions covering tuition fees,
              travel, and living expenses.
            </p>

            <p className="subtitle">
              Whether you are planning for premier institutes in India or
              prestigious universities abroad, we provide flexible repayment
              options that start only after you complete your course and secure
              a job.
            </p>

            <p className="subtitle">
              With competitive interest rates and a simplified documentation
              process, we ensure that your focus remains entirely on your
              studies while we handle the financing for your bright future.
            </p>
          </div>

          {/* 5. Action Button */}
          <div className="cta-wrapper animated-item">
            <button
              className="high-conversion-btn"
              onClick={() => {
                navigate("/services/6", { state: { scrollToApply: true } });
              }}
            >
              <span className="btn-text">Apply For Education Loan</span>
              <div className="btn-glow-shimmer"></div>
            </button>
          </div>
        </div>
      </section>
      <TestimonialsSection />

      <Services
        slug="6"
        title="Education Loan EMI Calculator – Calculate Your Monthly EMI Online
"
      />
    </div>
  );
};

export default EducationLoan;
